import { render, staticRenderFns } from "./MultiplierBreakdownTab.vue?vue&type=template&id=632360da&scoped=true&"
import script from "./MultiplierBreakdownTab.vue?vue&type=script&lang=js&"
export * from "./MultiplierBreakdownTab.vue?vue&type=script&lang=js&"
import style0 from "./MultiplierBreakdownTab.vue?vue&type=style&index=0&id=632360da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632360da",
  null
  
)

export default component.exports